export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updateTime: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  updateTime: string;
  views: number;
  chapters: MangaChapter[];
  tags: string[];
}

export const categories = [
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line' },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line' },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line' },
  { name: '武侠', slug: 'wuxia', icon: 'ri-sword-line' },
  { name: '校园', slug: 'xiaoyuan', icon: 'ri-building-line' },
  { name: '都市', slug: 'dushi', icon: 'ri-building-2-line' },
  { name: '恐怖', slug: 'kongbu', icon: 'ri-ghost-line' },
  { name: '日漫', slug: 'riman', icon: 'ri-sun-line' },
  { name: '国漫', slug: 'guoman', icon: 'ri-china-railway-fill' },
];

export const mockMangaList: Manga[] = [
  {
    id: 'manga-1',
    title: '星辰变',
    author: '我吃西红柿',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20art%20style%2C%20fantasy%20cultivation%20theme%2C%20a%20young%20warrior%20in%20flowing%20robes%20holding%20a%20glowing%20sword%20against%20a%20starry%20night%20sky%20background%2C%20dynamic%20composition%2C%20vibrant%20warm%20orange%20and%20gold%20accents%2C%20manga%20cover%20design%20with%20clean%20layout%2C%20soft%20gradient%20background&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '连载中',
    rating: 9.5,
    description: '一部讲述少年踏上修仙之路的热血故事。主角秦羽从凡人一步步修炼成神，历经无数磨难与挑战，在广袤的星辰宇宙中书写属于自己的传奇。故事情节跌宕起伏，世界观宏大壮阔，是国产漫画中不可多得的精品之作。',
    updateTime: '2026-08-04',
    views: 1285000,
    chapters: [
      { id: 'ch-1-1', title: '第1话 星辰之始', number: 1, updateTime: '2026-01-15' },
      { id: 'ch-1-2', title: '第2话 初入修真', number: 2, updateTime: '2026-01-22' },
      { id: 'ch-1-3', title: '第3话 突破境界', number: 3, updateTime: '2026-01-29' },
      { id: 'ch-1-4', title: '第4话 秘境探险', number: 4, updateTime: '2026-02-05' },
      { id: 'ch-1-5', title: '第5话 天劫降临', number: 5, updateTime: '2026-02-12' },
      { id: 'ch-1-6', title: '第6话 涅槃重生', number: 6, updateTime: '2026-02-19' },
      { id: 'ch-1-7', title: '第7话 星辰之力', number: 7, updateTime: '2026-02-26' },
      { id: 'ch-1-8', title: '第8话 远古遗迹', number: 8, updateTime: '2026-03-04' },
    ],
    tags: ['热血', '修仙', '玄幻', '战斗'],
  },
  {
    id: 'manga-2',
    title: '甜蜜陷阱',
    author: '夏小沫',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20romance%20manhua%20cover%2C%20two%20young%20characters%20facing%20each%20other%20with%20cherry%20blossom%20petals%20floating%20around%2C%20soft%20pink%20and%20warm%20peach%20color%20palette%2C%20gentle%20expression%2C%20manga%20cover%20art%20style%2C%20clean%20design%20with%20romantic%20atmosphere&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    rating: 9.2,
    description: '青梅竹马的两小无猜，从校园到职场的甜蜜爱恋。林小雨和陈默从小一起长大，经历了误会、分离和重逢，最终发现彼此才是命中注定的那个人。温暖治愈的恋爱故事，让人重拾对爱情的美好向往。',
    updateTime: '2026-08-03',
    views: 986000,
    chapters: [
      { id: 'ch-2-1', title: '第1话 青梅竹马', number: 1, updateTime: '2026-02-01' },
      { id: 'ch-2-2', title: '第2话 心跳加速', number: 2, updateTime: '2026-02-08' },
      { id: 'ch-2-3', title: '第3话 误会重重', number: 3, updateTime: '2026-02-15' },
      { id: 'ch-2-4', title: '第4话 雨中的告白', number: 4, updateTime: '2026-02-22' },
      { id: 'ch-2-5', title: '第5话 甜蜜约会', number: 5, updateTime: '2026-03-01' },
      { id: 'ch-2-6', title: '第6话 情敌出现', number: 6, updateTime: '2026-03-08' },
    ],
    tags: ['恋爱', '校园', '治愈', '甜宠'],
  },
  {
    id: 'manga-3',
    title: '爆笑校园',
    author: '朱斌',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20comedy%20manhua%20cover%2C%20exaggerated%20cartoon%20characters%20in%20school%20uniform%20making%20silly%20faces%2C%20bright%20and%20vivid%20colors%20with%20yellow%20and%20green%20accents%2C%20playful%20and%20humorous%20manga%20style%2C%20clean%20composition&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '已完结',
    rating: 9.0,
    description: '呆头是一个来自农村的转学生，他用独特的思维方式面对城市校园生活，闹出了无数令人捧腹的笑话。从课堂趣事到宿舍囧事，从运动会乌龙到考试风波，每一页都充满了让人忍俊不禁的欢乐。',
    updateTime: '2026-07-20',
    views: 2150000,
    chapters: [
      { id: 'ch-3-1', title: '第1话 转学生来了', number: 1, updateTime: '2025-06-01' },
      { id: 'ch-3-2', title: '第2话 课堂囧事', number: 2, updateTime: '2025-06-08' },
      { id: 'ch-3-3', title: '第3话 食堂大战', number: 3, updateTime: '2025-06-15' },
      { id: 'ch-3-4', title: '第4话 运动会风云', number: 4, updateTime: '2025-06-22' },
      { id: 'ch-3-5', title: '第5话 考试大作战', number: 5, updateTime: '2025-06-29' },
      { id: 'ch-3-6', title: '第6话 宿舍夜话', number: 6, updateTime: '2025-07-06' },
      { id: 'ch-3-7', title: '第7话 春游奇遇', number: 7, updateTime: '2025-07-13' },
      { id: 'ch-3-8', title: '第8话 毕业季', number: 8, updateTime: '2025-07-20' },
    ],
    tags: ['搞笑', '校园', '日常', '轻松'],
  },
  {
    id: 'manga-4',
    title: '暗夜追踪',
    author: '墨渊',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20thriller%20manhua%20cover%2C%20a%20detective%20in%20trench%20coat%20standing%20in%20a%20rainy%20alley%20with%20streetlamp%20lighting%2C%20noir%20atmosphere%2C%20deep%20blue%20and%20dark%20teal%20tones%2C%20suspenseful%20manga%20cover%20art%2C%20clean%20composition%20with%20dramatic%20shadows&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    rating: 9.3,
    description: '一起离奇的连环杀人案，将天才侦探沈夜卷入了一场前所未有的阴谋。每一个案件现场都留下了一个神秘的符号，随着调查的深入，沈夜发现自己正在接近一个足以颠覆整个城市的黑暗秘密。悬念迭起，反转不断。',
    updateTime: '2026-08-02',
    views: 756000,
    chapters: [
      { id: 'ch-4-1', title: '第1话 雨夜命案', number: 1, updateTime: '2026-03-15' },
      { id: 'ch-4-2', title: '第2话 神秘符号', number: 2, updateTime: '2026-03-22' },
      { id: 'ch-4-3', title: '第3话 第二名受害者', number: 3, updateTime: '2026-03-29' },
      { id: 'ch-4-4', title: '第4话 蛛丝马迹', number: 4, updateTime: '2026-04-05' },
      { id: 'ch-4-5', title: '第5话 嫌疑人浮现', number: 5, updateTime: '2026-04-12' },
    ],
    tags: ['悬疑', '推理', '都市', '犯罪'],
  },
  {
    id: 'manga-5',
    title: '机甲纪元',
    author: '铁甲依然在',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20mecha%20manhua%20cover%2C%20a%20giant%20futuristic%20robot%20standing%20in%20a%20cyberpunk%20cityscape%20with%20neon%20lights%2C%20metallic%20silver%20and%20electric%20cyan%20color%20scheme%2C%20dynamic%20action%20pose%2C%20manga%20cover%20art%20style%2C%20clean%20design&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    rating: 8.8,
    description: '公元2150年，人类进入机甲时代。少年林锋意外获得一台远古机甲，从此踏上拯救世界的征程。宏大的科幻世界观，炫酷的机甲设计，热血的战斗场面，带你进入一个充满想象力的未来世界。',
    updateTime: '2026-08-01',
    views: 623000,
    chapters: [
      { id: 'ch-5-1', title: '第1话 废铁觉醒', number: 1, updateTime: '2026-04-01' },
      { id: 'ch-5-2', title: '第2话 初次驾驶', number: 2, updateTime: '2026-04-08' },
      { id: 'ch-5-3', title: '第3话 机甲学院', number: 3, updateTime: '2026-04-15' },
      { id: 'ch-5-4', title: '第4话 模拟对战', number: 4, updateTime: '2026-04-22' },
      { id: 'ch-5-5', title: '第5话 实战首秀', number: 5, updateTime: '2026-04-29' },
      { id: 'ch-5-6', title: '第6话 危机降临', number: 6, updateTime: '2026-05-06' },
    ],
    tags: ['科幻', '机甲', '未来', '热血'],
  },
  {
    id: 'manga-6',
    title: '剑道独尊',
    author: '剑游太虚',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20wuxia%20manhua%20cover%2C%20a%20swordsman%20in%20traditional%20hanfu%20robes%20on%20a%20bamboo%20forest%20mountain%20peak%2C%20ink%20wash%20painting%20style%20with%20elegant%20brushstrokes%2C%20warm%20sepia%20and%20jade%20green%20tones%2C%20classical%20Chinese%20aesthetic&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: '武侠',
    categorySlug: 'wuxia',
    status: '已完结',
    rating: 9.4,
    description: '剑神叶尘重生回到少年时代，带着前世的记忆和剑道感悟，他重新踏上剑道巅峰之路。前世遗憾今生弥补，前世敌人今生碾压。一部酣畅淋漓的剑道传奇，让人热血沸腾的武侠盛宴。',
    updateTime: '2026-07-15',
    views: 1870000,
    chapters: [
      { id: 'ch-6-1', title: '第1话 剑神重生', number: 1, updateTime: '2025-08-01' },
      { id: 'ch-6-2', title: '第2话 初露锋芒', number: 2, updateTime: '2025-08-08' },
      { id: 'ch-6-3', title: '第3话 宗门大比', number: 3, updateTime: '2025-08-15' },
      { id: 'ch-6-4', title: '第4话 一剑封喉', number: 4, updateTime: '2025-08-22' },
      { id: 'ch-6-5', title: '第5话 名动天下', number: 5, updateTime: '2025-08-29' },
      { id: 'ch-6-6', title: '第6话 江湖风云', number: 6, updateTime: '2025-09-05' },
      { id: 'ch-6-7', title: '第7话 剑道巅峰', number: 7, updateTime: '2025-09-12' },
    ],
    tags: ['武侠', '重生', '剑道', '热血'],
  },
  {
    id: 'manga-7',
    title: '青春纪念册',
    author: '落落',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20school%20manhua%20cover%2C%20group%20of%20teenagers%20sitting%20on%20school%20rooftop%20under%20blue%20sky%20with%20white%20clouds%2C%20warm%20sunlight%20and%20gentle%20breeze%2C%20nostalgic%20youth%20atmosphere%2C%20soft%20pastel%20colors%2C%20manga%20cover%20art%20style&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: '校园',
    categorySlug: 'xiaoyuan',
    status: '连载中',
    rating: 9.1,
    description: '高中三年，是一生中最美好的时光。五个性格迥异的少年少女，在青春的路上相遇、相知、相伴。有欢笑，有泪水，有争吵，也有和解。这是一本关于青春、友情和梦想的纪念册。',
    updateTime: '2026-08-03',
    views: 543000,
    chapters: [
      { id: 'ch-7-1', title: '第1话 开学第一天', number: 1, updateTime: '2026-05-01' },
      { id: 'ch-7-2', title: '第2话 同桌的你', number: 2, updateTime: '2026-05-08' },
      { id: 'ch-7-3', title: '第3话 社团招新', number: 3, updateTime: '2026-05-15' },
      { id: 'ch-7-4', title: '第4话 学园祭', number: 4, updateTime: '2026-05-22' },
    ],
    tags: ['校园', '青春', '友情', '日常'],
  },
  {
    id: 'manga-8',
    title: '都市传说',
    author: '午夜咖啡馆',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20horror%20supernatural%20manhua%20cover%2C%20a%20shadowy%20figure%20emerging%20from%20darkness%20in%20an%20abandoned%20urban%20building%2C%20eerie%20green%20and%20dark%20purple%20atmosphere%2C%20spooky%20and%20mysterious%20vibe%2C%20manga%20cover%20art%20style%2C%20clean%20design&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: '恐怖',
    categorySlug: 'kongbu',
    status: '连载中',
    rating: 8.7,
    description: '每个城市都有不为人知的都市传说。大学生林晓搬进了一栋租金异常便宜的老公寓，从此怪事不断。午夜的水滴声、镜中的陌生面孔、走廊尽头的脚步声……这些都市传说中的恐怖元素，正在她的生活中一一应验。',
    updateTime: '2026-07-30',
    views: 432000,
    chapters: [
      { id: 'ch-8-1', title: '第1话 便宜公寓', number: 1, updateTime: '2026-05-01' },
      { id: 'ch-8-2', title: '第2话 午夜滴水', number: 2, updateTime: '2026-05-08' },
      { id: 'ch-8-3', title: '第3话 镜中人', number: 3, updateTime: '2026-05-15' },
      { id: 'ch-8-4', title: '第4话 走廊尽头', number: 4, updateTime: '2026-05-22' },
    ],
    tags: ['恐怖', '都市', '灵异', '悬疑'],
  },
  {
    id: 'manga-9',
    title: '霸王传说',
    author: '天下霸唱',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20war%20manhua%20cover%2C%20a%20powerful%20general%20on%20horseback%20leading%20an%20army%20with%20flags%20waving%2C%20epic%20battlefield%20scene%2C%20warm%20crimson%20and%20gold%20tones%2C%20heroic%20and%20majestic%20manga%20cover%20art%2C%20clean%20composition&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 9.6,
    description: '乱世之中，英雄辈出。少年项羽从一个普通农户之子，凭借过人的勇武和智慧，一步步成长为威震天下的西楚霸王。宏大的历史画卷，热血的战争场面，跌宕起伏的权谋斗争，再现那段波澜壮阔的历史。',
    updateTime: '2026-08-04',
    views: 2340000,
    chapters: [
      { id: 'ch-9-1', title: '第1话 少年英雄', number: 1, updateTime: '2026-01-10' },
      { id: 'ch-9-2', title: '第2话 初入江湖', number: 2, updateTime: '2026-01-17' },
      { id: 'ch-9-3', title: '第3话 揭竿而起', number: 3, updateTime: '2026-01-24' },
      { id: 'ch-9-4', title: '第4话 巨鹿之战', number: 4, updateTime: '2026-01-31' },
      { id: 'ch-9-5', title: '第5话 鸿门宴', number: 5, updateTime: '2026-02-07' },
      { id: 'ch-9-6', title: '第6话 分封天下', number: 6, updateTime: '2026-02-14' },
      { id: 'ch-9-7', title: '第7话 楚汉争霸', number: 7, updateTime: '2026-02-21' },
    ],
    tags: ['热血', '历史', '战争', '权谋'],
  },
  {
    id: 'manga-10',
    title: '总裁的替身新娘',
    author: '安知晓',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20romance%20manhua%20cover%2C%20a%20handsome%20CEO%20in%20suit%20and%20a%20beautiful%20woman%20in%20elegant%20dress%2C%20luxury%20city%20skyline%20background%2C%20sophisticated%20and%20glamorous%20style%2C%20warm%20champagne%20gold%20tones%2C%20manga%20cover%20art&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: '都市',
    categorySlug: 'dushi',
    status: '已完结',
    rating: 8.9,
    description: '为了救重病的母亲，苏小暖代替双胞胎姐姐嫁给了传说中的冷酷总裁。原以为是一场交易，却没想到冰山总裁的心在慢慢融化。当真相被揭开的那一天，这段始于谎言的婚姻，还能继续下去吗？',
    updateTime: '2026-07-10',
    views: 1560000,
    chapters: [
      { id: 'ch-10-1', title: '第1话 替嫁', number: 1, updateTime: '2025-09-01' },
      { id: 'ch-10-2', title: '第2话 新婚之夜', number: 2, updateTime: '2025-09-08' },
      { id: 'ch-10-3', title: '第3话 冰山融化', number: 3, updateTime: '2025-09-15' },
      { id: 'ch-10-4', title: '第4话 危机来临', number: 4, updateTime: '2025-09-22' },
      { id: 'ch-10-5', title: '第5话 真相大白', number: 5, updateTime: '2025-09-29' },
      { id: 'ch-10-6', title: '第6话 完美结局', number: 6, updateTime: '2025-10-06' },
    ],
    tags: ['都市', '恋爱', '总裁', '甜宠'],
  },
  {
    id: 'manga-11',
    title: '火影忍者',
    author: '岸本齐史',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20ninja%20manga%20cover%20style%2C%20a%20young%20ninja%20with%20spiky%20hair%20in%20orange%20outfit%20running%20through%20a%20village%2C%20dynamic%20action%20pose%2C%20vibrant%20orange%20and%20blue%20color%20contrast%2C%20manga%20cover%20art%20design&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    status: '已完结',
    rating: 9.8,
    description: '在木叶忍者村，有一个叫漩涡鸣人的少年，他体内封印着九尾妖狐。为了获得所有人的认可，鸣人立志成为最强的火影。这是一部关于友情、努力和梦想的传奇故事，影响了一代人的经典之作。',
    updateTime: '2026-06-20',
    views: 5200000,
    chapters: [
      { id: 'ch-11-1', title: '第1话 漩涡鸣人', number: 1, updateTime: '2024-01-01' },
      { id: 'ch-11-2', title: '第2话 宇智波佐助', number: 2, updateTime: '2024-01-08' },
      { id: 'ch-11-3', title: '第3话 卡卡西老师', number: 3, updateTime: '2024-01-15' },
      { id: 'ch-11-4', title: '第4话 波之国任务', number: 4, updateTime: '2024-01-22' },
      { id: 'ch-11-5', title: '第5话 中忍考试', number: 5, updateTime: '2024-01-29' },
      { id: 'ch-11-6', title: '第6话 大蛇丸来袭', number: 6, updateTime: '2024-02-05' },
    ],
    tags: ['日漫', '热血', '忍者', '经典'],
  },
  {
    id: 'manga-12',
    title: '斗罗大陆',
    author: '唐家三少',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20manhua%20cover%2C%20a%20young%20boy%20with%20blue%20silver%20grass%20spirit%20ring%20glowing%20around%20him%2C%20magical%20martial%20arts%20academy%20background%2C%20vibrant%20mystical%20colors%20with%20blue%20and%20gold%20accents%2C%20epic%20manga%20cover%20design&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    status: '连载中',
    rating: 9.7,
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志后却来到另一个世界——斗罗大陆。在这里，没有魔法，没有斗气，只有武魂。唐三带着前世的记忆，在斗罗大陆上开始了全新的传奇之旅。',
    updateTime: '2026-08-03',
    views: 6800000,
    chapters: [
      { id: 'ch-12-1', title: '第1话 唐门唐三', number: 1, updateTime: '2024-03-01' },
      { id: 'ch-12-2', title: '第2话 武魂觉醒', number: 2, updateTime: '2024-03-08' },
      { id: 'ch-12-3', title: '第3话 诺丁学院', number: 3, updateTime: '2024-03-15' },
      { id: 'ch-12-4', title: '第4话 史莱克七怪', number: 4, updateTime: '2024-03-22' },
      { id: 'ch-12-5', title: '第5话 魂师大赛', number: 5, updateTime: '2024-03-29' },
      { id: 'ch-12-6', title: '第6话 杀戮之都', number: 6, updateTime: '2024-04-05' },
    ],
    tags: ['国漫', '玄幻', '热血', '冒险'],
  },
];

export const rankings = mockMangaList
  .sort((a, b) => b.views - a.views)
  .slice(0, 10);

export const latestUpdates = mockMangaList
  .sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime())
  .slice(0, 8);

export const hotRecommend = mockMangaList
  .sort((a, b) => b.rating - a.rating)
  .slice(0, 6);